import React, { useContext, useEffect, useRef, useState } from 'react';
import { WelletContext } from '../../context/WelletContext';

import { useDispatch, useSelector } from 'react-redux';
import { setCanRefresh } from '../../actions/appActions';
import { resetReservation, setReservation } from '../../actions/reservationActions';
import { useTranslation } from 'react-i18next';
import { getQueryString } from '../../helpers/url';
import { CircleSpinner } from 'react-spinners-kit';
import {
  convertTime12to24,
  formatDateNormal,
  formatDateTime,
  getDateFromOffset,
  getLocale,
} from '../../helpers/dates';
import { closestIndexTo, format } from 'date-fns';
import Header from '../../components/Common/Header/Header';
import Button from '../../components/Common/Button/Button';
import BookSelector from '../../components/BookSelector/BookSelector';
import { Navigation, Pagination } from 'swiper/modules';

import styles from './VenueDetail.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

import './styles.css';
import { Skeleton } from '@mui/material';
import ContentApp from '../../components/ContentApp';
import MarkerIcon from '../../components/icons/MarkerIcon';
import QrIcon from '../../components/icons/QrIcon';
import Line from '../../components/Common/Line/Line';
import ProductModal from '../../components/Common/ProductModal/ProductModal';
import ShareIcon from '../../components/icons/ShareIcon';
import Qr from '../../components/Common/Qr/Qr';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import Money from '../../components/Common/Money/Money';
import BottomSheetComponent from '../../components/BottomSheet/BottomSheet';
import BottomSheet from '../../components/BottomSheet/BottomSheet';

const VenueDetail = ({ history }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const market = useSelector((state) => state.app.currentMarket);
  const reservation = useSelector((state) => state.reservation);
  const locale = getLocale(language);
  const showId = getQueryString('showId');
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(null);
  const [timeSelected, setTimeSelected] = useState(null);
  const [today, setToday] = useState(null);
  const [openQr, setOpenQr] = useState(false);
  const [loadingIntervals, setLoadingIntervals] = useState(true);
  const [hasRestaurant, setHasRestaurant] = useState(true);
  const company = useSelector((state) => state.app);
  const qrLink = useSelector((state) => state.associates.user.qrUserUrl);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [intervals, setIntervals] = useState([]);
  const swiperTimeRef = useRef(null);
  const swiperRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [overlayHeight, setOverlayHeight] = useState(0);

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: company.name,
          url: qrLink,
        });
      } else {
        console.warn('Web Share API not supported in this browser.');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: showId,
          lang: language,
          details: true,
          reservationType: 'RESTAURANT',
          images: true,
          videos: true,
          IsFeature: true,
        },
      });

      setShow(result.data);
      const hasRestaurant = result.data.reservationTypes.some((item) => item.type === 'RESTAURANT');

      setHasRestaurant(hasRestaurant);

      let todayDate = new Date(getDateFromOffset(result.data.utcOffset));

      const minutes = todayDate.getMinutes();
      todayDate.setMinutes(minutes === 0 ? minutes : minutes + (15 - (minutes % 15)), 0, 0);

      setToday(todayDate);

      if (
        !reservation.date ||
        formatDateTime(reservation.date, reservation.performance) < todayDate
      ) {
        dispatch(
          setReservation({
            date: format(todayDate, 'yyyy-MM-dd'),
          }),
        );
      }

      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //   const getSchedule = async (date, reservationType, paxs = null, hour = null) => {
  //     setLoadingIntervals(true);
  //     try {
  //       let params = `showId=${showId}&date=${date}&reservationType=${reservationType}&details=true`;
  //       if (hour) {
  //         params += `&hour=${hour}`;
  //       }
  //       if (paxs) {
  //         params += `&paxs=${paxs}`;
  //       }

  //       const result = await welletContext.apis.tickets.get(`/shows/GetSchedule?${params}`);

  //       if (result.data.schedules.length === 0) {
  //         setIntervals([]);
  //       }

  //       const formattedTimes = result.data?.schedules?.map((time) => {
  //         const time24 = new Date(date + 'T' + convertTime12to24(time.timeStart));

  //         if (time.timeMinutesStart >= 0 && time.timeMinutesStart <= 360)
  //           time24.setDate(time24.getDate() + 1);

  //         return { time24, soldOut: time.isSoldOut, availabilityRefId: time.availabilityRefId };
  //       });
  //       formattedTimes.sort();

  //       const allIntervals = formattedTimes.map(({ time24, soldOut, availabilityRefId }) => ({
  //         time: time24,
  //         soldOut,
  //         availabilityRefId,
  //       }));

  //       setIntervals(allIntervals.filter((x) => !x.soldOut));
  //       // setClosedTime(
  //       //   referenceDate,
  //       //   allIntervals.map((item) => item.time),
  //       // );

  //       //setLoadingIntervals(false);f
  //     } catch (error) {
  //       console.error(error);
  //     }
  //     setLoadingIntervals(false);
  //   };

  const setClosedTime = (date, intervals) => {
    if (swiperTimeRef.current && swiperTimeRef.current.swiper) {
      const index = closestIndexTo(date, intervals);
      swiperTimeRef.current.swiper.slideTo(index);
    }
  };

  const headerHtml = () => {
    return (
      <div className='mt-4 pb-2'>
        <h1 className='font-large m-0'>{show.name}</h1>
        <span className='text-secondary'>{show.city.name}</span>
      </div>
    );
  };

  const onTimeClick = (time, availabilityRefId) => {
    const reservationInfo = {
      ...reservation,
      showId: showId,
      showName: show.name,
      performance: time,
      availabilityRefId,
      products: null,
      imageUrl: show.imageUrl,
    };

    dispatch(setReservation(reservationInfo));

    history.push({
      pathname: '/reservation-check',
      search: `?show=${show.name}`,
    });
  };

  const onSocialClick = (social) => {
    window.open(social.value, '_blank');
  };

  const onEventClick = (eventId) => {
    history.push({
      pathname: '/event',
      search: `?eventId=${eventId}`,
    });
  };

  const getLocation = () => {
    const address = show.address.split(',').map((str) => str.trim());
    const textCity = show.city.nameLong.split(',').map((str) => str.trim());
    let secondLine = show.postalCode;

    if (address.length > 1) secondLine = `${address[1]}, ${secondLine}`;

    return (
      <div>
        <div>{address[0]}</div>
        <div>{secondLine}</div>
        <div>{`${textCity[0]}, ${textCity[1]}`}</div>
        <div>{textCity[2]}</div>
        {show.latitude && show.longitude && (
          <div className={styles.locationMap}>
            {!mapLoaded && (
              <Skeleton
                variant='rectangular'
                sx={{
                  bgcolor: 'grey.900',
                  width: '100%',
                  height: '100%',
                  borderRadius: '.4rem',
                }}
              />
            )}

            <img
              className={`${mapLoaded ? '' : 'd-none'}`}
              src={`https://tile1.gosurmaps.com/styles/gosur/static/${show.longitude},${show.latitude},16/400x400@2x.png`}
              onLoad={() => setMapLoaded(true)}
              alt='map'
            />
            <div className={`${styles.marker} ${mapLoaded ? '' : 'd-none'}`}>
              <MarkerIcon size={32} color={'#ea4335'} />
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderButtons = () => {
    return (
      <>
        <h1 className='font-large fw-600 m-0'>{show.name}</h1>
        <span className='text-secondary'>{show.city.name}</span>
        <div className='mt-4 pt-4' style={{ borderTop: '1px solid #3d3d3d' }}>
          <div className='mb-3'>
            {show?.reservationTypes.map((category) => (
              <div className='mb-3' key={category.id}>
                <Button
                  className={styles.btnCategory}
                  onClick={() => handleClick(category)}
                  size={'normal'}
                  text={
                    category.type === 'GROUP'
                      ? t('reservationgroupbutton')
                      : category.type === 'AREA'
                      ? t('reservationarea')
                      : category.type === 'TICKET'
                      ? t('events')
                      : t('reservationrestaurant')
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  //   const renderEvents = () => {
  //     if (show.events <= 0) return;

  //     return (
  //       <div className='mt-4 pt-4' style={{ borderTop: '1px solid #3d3d3d' }}>
  //         <div className='row'>
  //           <div className='col fw-bold'>{t('nextEvents')}</div>
  //           <div className='col-auto text-tertiary font-tiny my-auto'>
  //             <Link to={'/event-selector?showId=' + showId} className='text-secondary'>
  //               {t('viewAll')}
  //             </Link>
  //           </div>
  //         </div>

  //         <div className='event-list mt-3'>
  //           <Swiper spaceBetween={25} slidesPerView={'auto'}>
  //             {show.events.map((item) => (
  //               <SwiperSlide key={item.id}>
  //                 <div className={styles.eventItem} onClick={() => onEventClick(item.id)}>
  //                   <div>
  //                     <img src={item.bannerImage} alt='banner-img' />
  //                   </div>
  //                   <div className='font-tiny fw-bold mt-2'>{item.name}</div>
  //                   <div className='font-tiny text-lighter-gray mt-2'>
  //                     {formatDateNormal(item.startDate, locale)}
  //                   </div>
  //                 </div>
  //               </SwiperSlide>
  //             ))}
  //           </Swiper>
  //         </div>
  //       </div>
  //     );
  //   };

  //   const renderBookSelector = () => {
  //     return (
  //       <div className='mt-1 pt-3' style={{ borderTop: '1px solid #3d3d3d' }}>
  //         <div className='book-selector-container'>
  //           {today && <BookSelector today={today} lang={language} onChange={onBookSelectorChange} />}

  //           <div className='mt-3' style={{ height: '40px' }}>
  //             <Swiper
  //               spaceBetween={10}
  //               slidesPerView={'auto'}
  //               centeredSlides={true}
  //               centeredSlidesBounds={true}
  //               ref={swiperTimeRef}
  //             >
  //               {loadingIntervals
  //                 ? [...Array(5)].map((_, i) => (
  //                     <SwiperSlide key={i}>
  //                       <Skeleton
  //                         variant='rectangular'
  //                         sx={{
  //                           bgcolor: '#191919',
  //                           width: '78px',
  //                           borderRadius: '5px',
  //                           height: 38,
  //                         }}
  //                       />
  //                     </SwiperSlide>
  //                   ))
  //                 : intervals.length === 0
  //                 ? [...Array(5)].map((_, i) => (
  //                     <SwiperSlide key={i}>
  //                       <button className='button-filter empty font-small'></button>
  //                     </SwiperSlide>
  //                   ))
  //                 : intervals.map((item, i) => (
  //                     <SwiperSlide key={i}>
  //                       <button
  //                         className={`button-filter font-small ${
  //                           timeSelected === null ? 'active' : ''
  //                         }`}
  //                         onClick={() =>
  //                           onTimeClick(format(item.time, 'HH:mm'), item.availabilityRefId)
  //                         }
  //                       >
  //                         {format(item.time, 'h:mm aaa')}
  //                       </button>
  //                     </SwiperSlide>
  //                   ))}
  //             </Swiper>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   };

  const contentHtml = () => {
    return (
      <div style={{ paddingBottom: 'calc(2rem + env(safe-area-inset-bottom))' }}>
        <div className={!show?.reservationTypes || !hasRestaurant ? '' : 'hide-content'}>
          {show.description && show.description.length > 0 && (
            <div className=' pt-4' style={{ borderTop: '1px solid #3d3d3d' }}>
              <div className='fw-bold'>{t('about')}</div>
              <div
                className='text-lighter-gray mt-2 description'
                dangerouslySetInnerHTML={{ __html: show.description }}
              />
            </div>
          )}

          <div className='mt-4 pt-4' style={{ borderTop: '1px solid #3d3d3d' }}>
            <div className='fw-bold'>{t('location')}</div>
            <div className='text-lighter-gray mt-2'>{getLocation()}</div>
          </div>
          {show.socialNetworks && show.socialNetworks.length > 0 && (
            <div className='mt-4 pt-4' style={{ borderTop: '1px solid #3d3d3d' }}>
              <div className='fw-bold'>{t('follow')}</div>
              <div className='text-lighter-gray mt-2'>
                {show.socialNetworks.map((p) => (
                  <div
                    className='text-primary'
                    onClick={() => onSocialClick(p)}
                    key={p.socialNetwork}
                  >
                    {p.value}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div
            onClick={() => setOpenQr(true)}
            className='mt-3 pb-3 d-flex align-items-center justify-content-center'
          >
            <div style={{ border: '1px solid #fff', borderRadius: '50%', padding: '8px' }}>
              <QrIcon color='#fff' />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleClick = (reservationType) => {

    if (reservationType.type === 'TICKET') {
      const welletProUrl = reservationType.externalAppUrl + `?showId=${reservationType.externalVenueId}#event-selector`;
      history.push({
        pathname: '/wellet-pro',
        search: `?url=${encodeURIComponent(welletProUrl)}`,
      });
      return;
    }

    const hasExternal = reservationType?.hasExternalPlatform;
    const type = reservationType?.type?.toLowerCase();

    history.push({
      pathname: type === 'restaurant' ? '/reservation-restaurant' : `/reservation/${type}`,
      search: `?showId=${showId}&platform=${hasExternal}`,
    });
  };

  //   const onBookSelectorChange = (e) => {
  //     getSchedule(e.date, 'RESTAURANT', e.pax, e.time);
  //   };

  //   useEffect(() => {
  //     if (show !== null && today !== null && hasRestaurant)
  //       getSchedule(
  //         reservation.date ? reservation.date : format(today, 'yyyy-MM-dd'),
  //         'RESTAURANT',
  //         reservation.paxs,
  //         reservation.performance ? reservation.performance : format(today, 'HH:mm'),
  //       );
  //   }, [show, today]);

  useEffect(() => {
    if (intervals) {
      const referenceDate = new Date(reservation.date + 'T' + reservation.performance);
      setClosedTime(
        referenceDate,
        intervals.map((item) => item.time),
      );
    }
  }, [intervals]);

  useEffect(() => {
    dispatch(setCanRefresh(false));

    dispatch(resetReservation());
    getShow();
    return () => {
      dispatch(setCanRefresh(true));
    };
  }, []);

  return (
    <>
      {loading ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <>
          <Header absolute={true} color='#fff' />

          <ContentApp classes={styles.borderNone}>
            <div className={styles.pageHeader}>
              <div className={`${styles.pageSection} ${styles.header}`}>
                <div className={styles.background}>
                  <Swiper
                    ref={swiperRef}
                    className={`swiper-show ${styles.swiperContainer}`}
                    pagination={true}
                    modules={[Navigation, Pagination]}
                    lazy={true}
                    style={{
                      '--swiper-pagination-top': overlayHeight + 'px',
                      '--swiper-pagination-bottom': 'none',
                      '--swiper-pagination-color': '#fff',
                      '--swiper-pagination-bullet-inactive-color': '#999999',
                      '--swiper-pagination-bullet-inactive-opacity': '1',
                      '--swiper-pagination-bullet-size': '7px',
                      '--swiper-pagination-bullet-horizontal-gap': '6px',
                    }}
                  >
                    {show?.videos &&
                      show.videos.map((video, index) => (
                        <SwiperSlide key={`video-${index}`}>
                          <div className={styles.overlay}>
                            <video
                              webkit-playsinline='true'
                              x5-playsinline='true'
                              playsInline
                              autoPlay
                              loop
                              muted
                              src={video.videoUrl}
                              alt='media'
                              style={{ width: '100%' }}
                            />
                          </div>
                        </SwiperSlide>
                      ))}

                    <SwiperSlide>
                      <div className={styles.overlay}>
                        <img
                          src={ show?.imageUrl}
                          alt={show.name}
                        />
                      </div>
                    </SwiperSlide>

                    {show?.images &&
                      show.images.map((image, index) => (
                        <SwiperSlide key={`image-${index}`}>
                          <div className={styles.overlay}>
                            <img src={image.imageUrl} alt='media' />
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>
            </div>
            <BottomSheet
              header={renderButtons()}
              content={contentHtml()}
              onSetHeight={(height) => setOverlayHeight(window.innerHeight - height - 30)}
            />

            <ProductModal
              animationClass='fade-up-down'
              open={openQr}
              hasBackground
              onClose={() => setOpenQr(false)}
              fullScreen
              backIcon
              customStyle={{
                backgroundColor: 'transparent',
                border: 'none',
              }}
            >
              <>
                <ContentApp>
                  <div className='card align-items-center p-3'>
                    <div className={styles.imageContainer}>
                      <img src={show.logoUrl} alt='logo' />
                    </div>
                    <div className='font-large fw-semibold my-2 text-center'>{show.name}</div>
                    <Line color='#353535' className='w-100 my-4' />

                    <Qr
                      qrUrl={show.link}
                      logo={show.logoUrl}
                      welletContext={welletContext}
                      logoBorder='ROUNDED'
                    />
                    <div className='font-large text-center fw-semibold m-3'>
                      {t('scanToMakeReservation')}
                    </div>
                  </div>

                  <div
                    className='text-center text-secondary font-small mt-3'
                    onClick={() => handleShare()}
                  >
                    {t('shareLinkToBook')}
                    <ShareIcon size={25} color={'#7e7e7e'} styles={{ marginLeft: '4px' }} />
                  </div>
                </ContentApp>
              </>
            </ProductModal>
          </ContentApp>
        </>
      )}
    </>
  );
};

export default VenueDetail;
